module.exports = __webpack_public_path__ + "img/title_bg.14308ecd.png";